import { ActionIcon, Affix, Transition } from '@mantine/core';
import { useMediaQuery, useWindowScroll } from '@mantine/hooks';
import { IconArrowUp } from '@tabler/icons-react';

/** Сколько надо уехать вниз, чтобы стрелка появилась: больше экрана телефона */
export const SCROLL_TOP_AFTER_PX = 400;

/**
 * Размер и место плавающих кнопок — одни на всех (правило 1): кнопка
 * поиска стоит над стрелкой, и разъедься их размеры, она легла бы на неё.
 * Палец крупнее мыши (правило 191): под палец — не меньше 48 точек.
 */
export const FLOAT_GAP = 20;
export const floatSize = (touch: boolean) => (touch ? 52 : 44);

/**
 * Стрелка «наверх» на длинных экранах.
 *
 * Выдача расходки — два десятка строк с подбором позиции у каждой, и до
 * кнопок наверху страницы на телефоне листать пальцем полминуты.
 * Владелец попросил прямо: «стрелочку вверх, которая поднимает страницу».
 *
 * ПОЯВЛЯЕТСЯ, ТОЛЬКО КОГДА УЕХАЛИ ВНИЗ. На короткой странице она была бы
 * лишней кнопкой поверх содержимого, а поверх полей ввода — помехой.
 *
 * ОДНА НА ВСЁ ПРИЛОЖЕНИЕ, а не у каждой страницы: длинными бывают и
 * наряд на день, и список сделок, и смета — вторая такая кнопка на
 * соседнем экране разошлась бы с первой на первой же правке (правило 1).
 *
 * На бумагу не печатается: лист договора со стрелкой в углу — не лист.
 */
export function ScrollTopButton() {
  const [scroll, scrollTo] = useWindowScroll();
  const touch = useMediaQuery('(pointer: coarse)', false, { getInitialValueInEffect: false });
  return (
    <Affix position={{ bottom: FLOAT_GAP, right: FLOAT_GAP }} className="no-print">
      <Transition transition="slide-up" mounted={scroll.y > SCROLL_TOP_AFTER_PX}>
        {(styles) => (
          <ActionIcon
            style={styles}
            size={floatSize(touch)}
            radius="xl"
            variant="filled"
            aria-label="Наверх"
            title="Наверх"
            onClick={() => scrollTo({ y: 0 })}
          >
            <IconArrowUp size={touch ? 26 : 22} />
          </ActionIcon>
        )}
      </Transition>
    </Affix>
  );
}
